import React from "react";
import { Dialog } from "./Dialog";
import Head from "./Head";
import { Flex, Heading, Box } from "@chakra-ui/react";
import { Large } from "./Type";
import Link from "./Link";

import Image from "next/image";

const SingleCardPage = ({
  title,
  backgroundColor,
  imageSrc,
  message,
  reverse = false,
  children,
}) => {
  return (
    <>
      <Head title={title} />
      <Flex
        paddingX={[4, 0, 0]}
        alignItems="center"
        justifyContent="center"
        h="100vh"
        direction="column"
      >
        <Dialog
          paddingX={4}
          marginTop={3}
          w={["80%", "65%", "30em"]}
          backgroundColor={backgroundColor}
        >
          <Flex
            justifyContent="space-between"
            alignItems="center"
            direction={reverse ? "row-reverse" : "row"}
          >
            <Box flexBasis="35%">
              <Image src={imageSrc} />
            </Box>
            <Box alignSelf="center" flexBasis="10%" flexGrow={1}>
              <Large
                textAlign={reverse ? "left" : "right"}
                marginTop={4}
                fontSize={["l", "l", "3xl"]}
                alignSelf="center"
              >
                {message}
              </Large>
              <Link href={"/"}>
                <Heading
                  alignSelf="center"
                  textAlign={reverse ? "left" : "right"}
                  as="h1"
                  fontSize={["xl", "2xl", "3xl"]}
                  textTransform="none"
                  p="0"
                  color="blackish"
                  fontWeight="light"
                  textDecoration="none"
                >
                  saweria.co
                </Heading>
              </Link>
            </Box>
          </Flex>
        </Dialog>
        {children}
      </Flex>
    </>
  );
};

export { SingleCardPage };
